export class GeneralController {

    constructor($scope, $rootScope, GeneralSettingsDao, XRayUIModelSaver, $state, SessionsDao, $q, $timeout,
                JFrogModal) {
        this.GeneralSettingsDao = GeneralSettingsDao;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$rootScope.h1Header='Xray General Settings';
        this.$scope = $scope;
        this.$timeout = $timeout
        this.$q = $q;
        this.modal = JFrogModal;
        this.SessionsDao = SessionsDao;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['settings', 'editableSysParamsObj']);
        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;
        $scope.$parent.Settings.saveButtonText = 'Save';
        this.boolOptions = ["true", "false"];
        this.setSysParamDictionary();
        this.getData();
        this.$timeout(() => {
            if (!this.$rootScope.licenseInvalid) {
                console.log('Getting system Params!');
                this.getSystemParams();
                this.getSystemParams();
            }
        }, 500);

        this.allowdParamsInUI = []
        $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
        })
    }

    originalObjChanged(oldObj, newObj) {

        return !_.isEqual(oldObj, newObj)
    }

    toggleAction(type) {

        if (type === 'sslInsecure') {

            this.sslInsecure === true ? this.sslInsecure = false : this.sslInsecure = true;

            if (this.sslInsecure) {
                this.editableSysParamsObj.sslInsecure = "true"

            } else {
                this.editableSysParamsObj.sslInsecure = "false"

            }
        }

        if (type === 'mailNoSsl') {

            this.mailNoSsl === true ? this.mailNoSsl = false : this.mailNoSsl = true;

            if (this.mailNoSsl) {
                this.editableSysParamsObj.mailNoSsl = "true"

            } else {
                this.editableSysParamsObj.mailNoSsl = "false"

            }
        }

        if (type === 'allowSendingAnalytics') {

            this.allowSendingAnalytics === true ? this.allowSendingAnalytics = false : this.allowSendingAnalytics = true;

            if (this.allowSendingAnalytics) {
                this.editableSysParamsObj.allowSendingAnalytics = "true"

            } else {
                this.editableSysParamsObj.allowSendingAnalytics = "false"

            }
        }

        this.checkParamsDiff()
    }

    setSysParamDictionary() {

        this.sysParamsDictonary = {
            "sslInsecure": {name: "SSL Insecure", desc: "To skip site's self-signed SSL certificate validation"},
            "maxDiskDataUsage": {
                name: "Max Disk Usage",
                desc: "Percentage of disk usage tolerated by Xray. When reaching the specified value, Xray will NOT download packages for indexing",
                unitType: "%"
            },
            "monitorSamplingInterval": {
                name: "Monitor Sampling Interval",
                desc: "Interval for executing monitoring (CPU, Disk Usage, restarts, etc.) job",
                unitType: "seconds"
            },
            "mailNoSsl": {
                name: "Mail Without SSL",
                desc: "This parameter should be active when Transport Layer Security is not used when connecting to the mail server"
            },
            "messageMaxTTL": {
                name: "Queue Message Max TTL",
                desc: "Number of retries to be accepted in Message Queue system",
                unitType: "quantity"
            },
            "jobInterval": {
                name: "Job Interval",
                desc: "Interval for running node specific jobs",
                unitType: "milliseconds"
            },
            "allowSendingAnalytics": {
                name: "Allow Sending Anonymous Usage Statistics",
                desc: "Help improve the JFrog Xray experience by sending anonymous usage statistics"
            }
        }
    }

    isValidParam(key){
        const ALLOWED_PARAMS = ['maxDiskDataUsage','monitorSamplingInterval','messageMaxTTL','jobInterval'];
        return _.includes(ALLOWED_PARAMS,key)
    }

    getData() {
        this.GeneralSettingsDao.get().$promise.then((settings) => {
            this.settings = this.transformSavedSettings(settings);
            this.sliderOptions = {
                floor: 1,
                ceil: 15,
                showTicks: true,
                showSelectionBar: true,
                onChange: () => {
                    this.checkWorkersDiff();
                }
            }

            this.originalWorkersObj = this.transformSavedSettings(this._pickFields(settings)).workers;
            this.modelSaver.save();
        })
    }

    checkWorkersDiff() {

        if (this.originalObjChanged(this.originalWorkersObj, this.settings.workers)) {
            this.showNote = true;
        } else {
            this.showNote = false;
        }
    }

    checkParamsDiff() {
        let stiringifiedTmpParams = {};
        _.map(this.editableSysParamsObj, (val, key) => {
            stiringifiedTmpParams[key] = val.toString();
        });

        if (this.originalObjChanged(this.originalSystemParams, stiringifiedTmpParams)) {
            this.showSysParamsNote = true;
        } else {
            this.showSysParamsNote = false;
        }


    }

    getSystemParams() {
        if (this.$rootScope.licenseInvalid) {
            return;
        }
        this.GeneralSettingsDao.getSystemParams().$promise.then((sysParams) => {

            this.editableSysParamsObj = _.cloneDeep(sysParams);
            delete  this.editableSysParamsObj.$promise;
            delete  this.editableSysParamsObj.$resolved;
            this.originalSystemParams = _.cloneDeep(this.editableSysParamsObj);


            this._transformParamsForEdit();
            this.modelSaver.save();
        });
    }

    _pickFields(data) {

        let finalData = _.pick(data, _.parseInt);

        return finalData
    }


    restoreDefault() {

        this.editableSysParamsObj = {
            "sslInsecure": "false",
            "maxDiskDataUsage": 80,
            "monitorSamplingInterval": 300,
            "mailNoSsl": "false",
            "messageMaxTTL": 20,
            "jobInterval": 86400,
            "allowSendingAnalytics": "true",
        }

        if (this.editableSysParamsObj.mailNoSsl == "true") {
            this.mailNoSsl = true;
        } else {
            this.mailNoSsl = false;
        }

        if (this.editableSysParamsObj.sslInsecure == "true") {
            this.sslInsecure = true;
        } else {
            this.sslInsecure = false;
        }

        if (this.editableSysParamsObj.allowSendingAnalytics == "true") {
            this.allowSendingAnalytics = true;
        } else {
            this.allowSendingAnalytics = false;
        }

    }

    restoreWorkersDefault() {
        this.settings.workers = {
            "index": 8,
            "bin_mgr": 8,
            "persist": 8,
            "alert": 8,
            "analysis": 8,
            "impact_analysis": 8,
            "notification": 8
        }

        this.checkWorkersDiff();
    }


    checkCredentials() {
        let defer = this.$q.defer();
        this.showCredentialsModal().then((loginData) => {
            let payload = {};
            payload.password = loginData.adminPass;
            payload.name = loginData.adminUser;
            this.SessionsDao.login({}, payload).$promise.then((response) => {
                if (response.admin) {
                    defer.resolve({isAdmin: true});
                } else {
                    defer.resolve({isAdmin: false});
                }

            }).catch(() => {
                defer.reject();
            });

        });
        return defer.promise;
    }


    save() {

        if (this.$rootScope.licenseInvalid) {
            this.updateUrl();
        } else {

            this.modal.confirm('Are you sure you want to change general settings ?').then((res) => {

                this.GeneralSettingsDao.update({}, this.transformSettingsForSave(this.settings)).$promise.then(
                    (response) => {
                        this.modelSaver.save();
                    });
                let payload = this._transformParamsForSave();
                this.GeneralSettingsDao.setSystemParams({}, payload).$promise.then((resp) => {
                });

            }).catch(() => {
                console.log('Save Aborted');
            });
        }
    }

    cancel() {
        this.$state.go('home');
    }

    transformSavedSettings(settings) {
        let transformed = {};
        transformed.xray_url = settings.xray_url;
        transformed.workers = {};
        for (let key in settings) {
            if (key.endsWith('_workers')) {
                let workerName = key.substr(0, key.lastIndexOf('_workers'));
                transformed.workers[workerName] = settings[key];
            }
        }
        return transformed;
    }

    transformSettingsForSave(settings) {
        let transformed = {}
        transformed.xray_url = settings.xray_url;
        for (let key in settings.workers) {
            transformed[key + '_workers'] = settings.workers[key];
        }
        return transformed;
    }

    _transformParamsForEdit() {


        if (this.editableSysParamsObj.mailNoSsl == "true") {
            this.mailNoSsl = true;
        } else {
            this.mailNoSsl = false;
        }

        if (this.editableSysParamsObj.sslInsecure == "true") {
            this.sslInsecure = true;
        } else {
            this.sslInsecure = false;
        }

        if (this.editableSysParamsObj.allowSendingAnalytics == "true") {
            this.allowSendingAnalytics = true;
        } else {
            this.allowSendingAnalytics = false;
        }

        _.each(this.editableSysParamsObj, (val, key) => {
            if (_.parseInt(val)) {
                this.editableSysParamsObj[key] = _.parseInt(val);
            }

        });
    }

    _transformParamsForSave() {

        let tempPayload = {}

        _.each(this.editableSysParamsObj, (val, key) => {

            tempPayload[key] = val.toString();

        });
        return tempPayload;
    }

    getPrettyWorkerName(key) {
        if (key === 'bin_mgr') {
            return 'Binary Manager';
        }
        if (key === 'impact_analysis') {
            return 'Impact Analysis';
        } else return _.capitalize(key);
    }

    canSave() {
        return this.generalSettingsForm.$valid;
    }

    checkLocalHost(retypeVal) {

        if (typeof retypeVal !== 'undefined') {

            if (retypeVal.toLowerCase().indexOf('/localhost:') > -1 || retypeVal.toLowerCase().indexOf('127.0.0.1') > -1) {

                return false;
            } else {

                return true;
            }
        }
        //return !retypeVal || (retypeVal && this.input.password === retypeVal);
    }

    checkURL(retypeVal) {
        let isValidIp = false;
        let isValidURL = false;
        if (typeof retypeVal !== 'undefined') {
            var res = retypeVal.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);

            if (/\b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))\b/ig.test(retypeVal)) {

                isValidIp = true;
            } else {

                isValidIp = false;
            }
            if (res == null) {

                isValidURL = false;

            }
            else {

                isValidURL = true;
            }

            if (isValidURL == false && isValidIp == false)
                return false;
            else
                return true;
        }

    }

    updateUrl() {
        console.log('Updating URL Only due to Invalid License');
        let xray_url = this.settings.xray_url;
        this.GeneralSettingsDao.updateXrayUrl({xray_url}).$promise.then((response) => {

            this.$state.go('home');
        });
    }

    showCredentialsModal() {

        let defer = this.$q.defer();
        let modalScope = this.$scope.$new();
        modalScope.type = "genericCheck";
        //modalScope.text = "Some text "
        modalScope.input = {};
        this.modal.launchModal('change_auth_modal', modalScope).result.then(() => {
            defer.resolve(modalScope.input);
        }).catch(() => {
            defer.reject();
        });


        return defer.promise;
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/general/general.controller.js